import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { redirect, routes } from '~/constants';
import { useStoreActions, useStoreStatic } from '~/contexts';
import { NotificationType } from '~/types/api/notification.model';
export const useApprovalEmailEntry = ()=>{
    const { setAuthToken } = useStoreActions();
    const { getState } = useStoreStatic();
    const navigate = useNavigate();
    const location = useLocation();
    const [payload, setPayload] = useState(null);
    useEffect(()=>{
        const notificationId = new URLSearchParams(location.search).get('nid');
        const locationState = location.state;
        const passedPayload = locationState === null || locationState === void 0 ? void 0 : locationState.notificationPayload;
        let cancelled = false;
        async function authorize(notificationId, payload) {
            if (payload.authToken != null) {
                await setAuthToken(payload.authToken);
                return true;
            }
            if (getState().authToken) return true;
            navigate(redirect.getPathAndSearch({
                returnTo: routes.notification(notificationId)
            }), {
                replace: true
            });
            return false;
        }
        async function enter() {
            if (notificationId == null) return navigate(routes.noAccessPage, {
                replace: true
            });
            if (passedPayload == null) return navigate(routes.notification(notificationId), {
                replace: true
            });
            if (passedPayload.type !== NotificationType.Invoice) {
                return navigate(routes.noAccessPage, {
                    replace: true
                });
            }
            const authorized = await authorize(notificationId, passedPayload);
            if (authorized && !cancelled) setPayload(passedPayload);
        }
        enter();
        return ()=>{
            cancelled = true;
        };
    }, [
        location.search,
        location.state
    ]);
    return {
        payload
    };
};
